// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

export interface ConfigInterface {
  backendBaseUrl: string;
  frontendBaseUrl: string;
  postLoginUrl: string;
  postLogoutUrl: string;
}

const { protocol, host } = window.location;
const frontendBaseUrl = `${protocol}//${host}`;

const configuration: ConfigInterface = {
  backendBaseUrl:
    process.env.REACT_APP_BACKEND_BASE_URL ||
    "MISSING_REACT_APP_BACKEND_BASE_URL",
  frontendBaseUrl,
  postLoginUrl: `${frontendBaseUrl}/login_callback`,
  postLogoutUrl: `${frontendBaseUrl}/logout_callback`
};

export default configuration;
